<template>
    <section id="page6">
        <div class="container">
            <div class="col-left">
                <div class="sticky">
                    <lottie-player :src="`animas/0/page07.json`" v-if="persona==0" ref="lottiepage7" id="page7anima0" class="anima"
                        loop="false"
                        transparent
                        >
                    </lottie-player>
                    <lottie-player :src="`animas/1/page07.json`" v-if="persona==1" ref="lottiepage7" id="page7anima1" class="anima"
                        loop="false"
                        transparent
                    >
                    </lottie-player>
                </div>
            </div>
            <div class="col-right">
                <h2>
                    Soluções variadas para a sua necessidade
                </h2>
                <p>
                    Cada cliente chega para nós com uma necessidade de aprendizado diferente. Nosso time tem a missão de avaliar e definir as rotas da jornada que estamos construindo.
                    <br><br>
                    Desenvolvemos game corporativo, superpage, WhatsApp learning, infográfico, podcast, vídeo aula, vídeo animação e muito mais.​
                </p>
            </div>
            <!-- <div class="col-right">
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Games corporativos</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva;</li>
                        <li>Permitem customizar a identidade visual e o conteúdo do game de acordo com o objetivo;</li>
                        <li>Estimulam o aprendizado e a avaliação de gaps técnicos ou comportamentais;</li>
                        <li>Apresentam feedbacks positivos e negativos aos colaboradores, de acordo com a tomada de decisões;</li>
                        <li>Em ambiente seguro, colaboradores poderão experimentar práticas do dia a dia com tomada de decisões que replicarão os riscos ou situações reais.</li>
                    </ul>
                </div>
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Analytics</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva para apresentar os resultados dos games realizados pelos colaboradores;</li>
                        <li>Cruzamento dos indicadores dos games com indicadores de negócios;</li>
                        <li>Permite exportar relatórios com a lista dos colaboradores e seus respectivos resultados;</li>
                        <li>Através dos dados, os gestores poderão traçar planos de ação para colaboradores que apresentarem gaps, como exemplo, a trilha on-line ou que participem de novos treinamentos de reforço.</li>
                    </ul>
                </div>
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Cursos on-line gamificados</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva;</li>
                        <li>Facilitam a fixação de conteúdo;</li>
                        <li>Permitem que o ritmo do aprendizado seja definido pelo próprio colaborador;</li>
                        <li>Oferecem ferramentas modernas de produção de conteúdo;</li>
                        <li>Reduzem o tempo gasto em sala de aula com o início e finalização;</li>
                        <li>Oferecem melhoria e agilidade no aprendizado através de técnicas de gamificação.</li>
                    </ul>
                </div>
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Superpage</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva em página com navegação vertical e rolagem longa;</li>
                        <li>Possibilita a inclusão de todo o treinamento, em que as informações são disponibilizadas em sessões para garantir uma navegação diferenciada e de uma forma leve e fácil;</li>
                        <li>Permite incluir nas sessões vídeos cartoons ou outros tipos de vídeos, podcasts e infográficos, que ajudam ainda mais na retenção do conhecimento.</li>
                    </ul>
                </div>
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Gen.te Desafia</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva;</li>
                        <li>Permite customizar a identidade visual e o conteúdo do aplicativo;</li>
                        <li>Estimula que os usuários se desafiem;</li>
                        <li>Possibilita criar grupo de desafios por temas e áreas;</li>
                        <li>Oferece ranking de desempenho;</li>
                        <li>Apresenta as estatísticas de acertos e erros por tema;</li>
                        <li>Fácil implantação, de forma que, em poucos dias, pode ser disponibilizado aos usuários.</li>
                    </ul>
                </div>
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Vídeo cartoon</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva;</li>
                        <li>Permite divulgar a informação de forma atraente, utilizando uma plataforma de vídeo com maior concentração de informação em um menor tempo.</li>
                    </ul>
                </div>
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Jogos de prateleira</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva;</li>
                        <li>Permitem customizar o logo;</li>
                        <li>Estimulam o aprendizado sobre temas transversais.</li>
                    </ul>
                    <p class="box">
                        Além dos títulos de prateleira, também temos parcerias estratégicas com a Fundação Dom Cabral e Kiembaum para trilhas 
                        que foram feitas sob medida por professores e consultores que vivenciam a prática das organizações e tornam o curso muito prático.
                    </p>
                </div>
                <div class="card">
                    <img src="@/assets/img/page6-placeholder.png" alt="">
                    <h2>Infográfico</h2>
                    <p class="tagline">
                        TAGLINE
                    </p>
                    <ul>
                        <li>Interface interativa e intuitiva;</li>
                        <li>Facilidade em compartilhar e entender informações complexas;</li>
                        <li>Podem ser personalizados visualmente de acordo com o público-alvo, tema, área de atuação e outros.</li>
                    </ul>
                </div>
            </div> -->
        </div>
    </section>
</template>
<script>
import { create } from '@lottiefiles/lottie-interactivity';
export default {
    props: ['persona'],
    mounted() {
        if(this.persona == 0) {
            this.$refs.lottiepage7.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page7anima0',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        } else {
            this.$refs.lottiepage7.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page7anima1',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        }
    }
}
</script>
<style lang="scss" scoped>
section {
    background-color: #F7F7F8;
    .container {
        padding-top: 56px;
        padding-bottom: 56px;
        // justify-content: flex-start;
        align-items: center;
        .col-left {
            align-self: stretch;
            display: flex;
            flex: 1 1 0%;
            flex-direction: column;
            margin-bottom: 30px;
            
            .persona {
                max-width: 100%;
                padding-bottom: 46px;
                padding-top: 30px;
            }
            h2 {
                padding-bottom: 30px;
            }
            .anima {
                max-width: 469px;
                margin: 0 auto;
            }
        }
        .col-right {
            flex-basis: 50%;
            h2 {
                padding-bottom: 30px;
            }
            .card {
                margin-bottom: 30px;
                display: flex;
                flex-direction: column;
                background-color: white;
                border-radius: 28px;
                box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                padding: 20px;
                img {
                    border-radius: 20px;
                    max-width: 100%;
                }
                h2 {
                    padding-top: 30px;
                    padding-bottom: 20px;
                }
                .tagline {
                    color: $color-secondary;
                    font-weight: bold;
                    padding-bottom: 30px;
                }
                ul {
                    list-style-position: inside;
                    line-height: 1.7rem;
                    padding-bottom: 10px;
                }
                .box {
                    background-color: rgba(0, 0, 0, .1);
                    border-radius: 20px;
                    padding: 20px;
                }
            }
        }

    }
    .sticky {
        position: sticky;
        position: -webkit-sticky;
        overflow: auto;
        top: 0;
    }
    @media only screen and (max-width: 1140px) {
        .container {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .col-left {
                flex-basis: 100%;
                padding-bottom: 30px;
                text-align: center;
            }
            .col-right {
                flex-basis: 100%;
            }
        }
    }
    @media only screen and (max-width: 600px) {
        .container {
            .col-right {
                flex-direction: column;
                .cards-right {
                    margin-top: 0;
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>